import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validNumberValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		if ((control as AbstractControl & { forcedValuePatching?: boolean }).forcedValuePatching) {
			return null;
		}

		const value = control.value;

		if (value === null || value === undefined || value === '') {
			return null; // Leere Werte werden nicht validiert
		}

		if (typeof value !== 'string' && typeof value !== 'number') {
			return { invalidNumber: true };
		}

		// Ersetzen von Komma durch Punkt für die numerische Validierung
		const normalizedValue = String(value).trim().replace(',', '.');
		if (normalizedValue === '') {
			return null;
		}

		// Überprüfung, ob der Wert eine gültige Zahl ist
		const isValid = Number.isFinite(Number(normalizedValue));

		return isValid ? null : { invalidNumber: true };
	};
}
